// extracted by mini-css-extract-plugin
export default {"items":"row-list_items__hVxVu","item":"row-list_item__WBPu8","card":"row-list_card__3om3w","scrollSnap":"row-list_scrollSnap__1YIu2"};